import styled from 'styled-components';
export const StyledNavHistory = styled.div `
  display: flex;
  > div {
    display: flex;
    flex-direction: column;
    button {
      transform: translateX(-0.25rem);
    }
  }
`;
